import { configure } from 'mobx';

import { injectStores } from '@mobx-devtools/tools';

import UserStore from './User/UserStore';
import DevicesStore from './Devices/DevicesStore';
import StationStore from './Station/StationStore';
import PermissionStore from './PermissionStore';
import AlertStore from './AlertStore';
import InvestigationStore from './Investigation/InvestigationStore';
import ProactiveEngineStore from './ProactiveEngineStore';
import RulesStore from './RulesStore';
import TrendsStore from './TrendsStore';
import ControlCenterStore from './ControlCenterStore/ControlCenterStore';
import UsersStore from './UsersStore';
import AssociableEntitiesStore from './AssociableEntitiesStore';
import MapBuilderStore from './MapBuilderStore';
import EnergySavingsStore from './EnergySavingsStore';
import EnergySavingsGraphStore from './EnergySavingsGraphStore';
import EulaStore from './EulaStore';
import StationRiskStore from './StationRiskStore';
import StationRiskGraphStore from './StationRiskGraphStore';
import LeakageStore from './LeakageStore';
import InsightsStore from './InsightsStore';
import { EngineStore } from './Engine/EngineStore';
import InstallationValidationStore from './InstallationValidation/InstallationValidationStore';
import SiteSurveyStore from './SiteSurveyForm/SiteSurveyStore';
import { ImageUploadStore } from './ImageUpload/ImageUploadStore';
import { LifecycleStore } from './Lifecycle/LifecycleStore';
import PIDEditStore from './PIDEditing/PIDEditStore';
import StationReadinessScoreStore from './StationReadinessScore/StationReadinessScoreStore';
import ReportStore from './Report/ReportStore';
import ChatbotStore from './ChatbotStore';
configure({ enforceActions: 'never' });

class RootStore {
  userStore: UserStore;
  devicesStore: DevicesStore;
  stationStore: StationStore;
  permissionStore: PermissionStore;
  alertStore: AlertStore;
  investigationStore: InvestigationStore;
  proactiveEngineStore: ProactiveEngineStore;
  rulesStore: RulesStore;
  trendsStore: TrendsStore;
  controlCenterStore: ControlCenterStore;
  usersStore: UsersStore;
  associableEntitiesStore: AssociableEntitiesStore;
  mapBuilderStore: MapBuilderStore;
  energySavingsStore: EnergySavingsStore;
  energySavingsGraphStore: EnergySavingsGraphStore;
  stationRiskStore: StationRiskStore;
  stationRiskGraphStore: StationRiskGraphStore;
  eulaStore: EulaStore;
  leakageStore: LeakageStore;
  insightsStore: InsightsStore;
  engineStore: EngineStore;
  installationValidationStore: InstallationValidationStore;
  siteSurveyStore: SiteSurveyStore;
  imageUploadStore: ImageUploadStore;
  lifecycleStore: LifecycleStore;
  pidEditStore: PIDEditStore;
  reportStore: ReportStore;
  stationReadinessScoreStore: StationReadinessScoreStore;
  chatbotStore: ChatbotStore;
  constructor() {
    this.userStore = new UserStore(this);
    this.devicesStore = new DevicesStore(this);
    this.stationStore = new StationStore(this);
    this.permissionStore = new PermissionStore(this);
    this.alertStore = new AlertStore(this);
    this.investigationStore = new InvestigationStore(this);
    this.proactiveEngineStore = new ProactiveEngineStore(this);
    this.rulesStore = new RulesStore(this);
    this.trendsStore = new TrendsStore(this);
    this.controlCenterStore = new ControlCenterStore(this);
    this.usersStore = new UsersStore(this);
    this.associableEntitiesStore = new AssociableEntitiesStore(this);
    this.mapBuilderStore = new MapBuilderStore(this);
    this.energySavingsStore = new EnergySavingsStore(this);
    this.energySavingsGraphStore = new EnergySavingsGraphStore(this);
    this.stationRiskStore = new StationRiskStore(this);
    this.stationRiskGraphStore = new StationRiskGraphStore(this);
    this.eulaStore = new EulaStore(this);
    this.leakageStore = new LeakageStore(this);
    this.insightsStore = new InsightsStore(this);
    this.engineStore = new EngineStore(this);
    this.installationValidationStore = new InstallationValidationStore(this);
    this.siteSurveyStore = new SiteSurveyStore(this);
    this.imageUploadStore = new ImageUploadStore();
    this.lifecycleStore = new LifecycleStore(this);
    this.pidEditStore = new PIDEditStore(this);
    this.reportStore = new ReportStore(this);
    this.stationReadinessScoreStore = new StationReadinessScoreStore(this);
    this.chatbotStore = new ChatbotStore(this);
  }
}

const rootStore: RootStore = new RootStore();
injectStores({ rootStore });
export default rootStore;
